import styled from 'styled-components';
import { BreakPoint } from 'styles/style-variables/breakpoint';

import { SText } from 'components/styled/SText';

export const TrialStartDelayBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  border-radius: 12px;
  background-color: #d8eeff;

  @media (max-width: ${BreakPoint.TabletTop}) {
    padding: 12px 16px;
  }

  @media (max-width: ${BreakPoint.MobileTop}) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const LaunchContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LaunchTrialText = styled(SText)`
  font-variant-numeric: lining-nums tabular-nums;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

export const LaunchingTrialDescription = styled(SText)`
  font-variant-numeric: lining-nums tabular-nums;
  font-size: 12px;
  line-height: 16px;
`;
